import React, { Component } from "react";
import { connect } from "react-redux";
import produce from "immer";
import { userClassCodeUpdate } from "../../actions/usersActions";

class ModifyCCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleInput: false,
      cName: ""
    };
  }

  componentDidMount() {
    const { cCodeDefault } = this.props;
    this.setState(
      produce(draft => {
        draft.cName = cCodeDefault;
      })
    );
  }

  toggleInput = () => {
    const { cCodeDefault } = this.props;

    this.setState(
      produce(draft => {
        draft.toggleInput = !draft.toggleInput;
        draft.cName = cCodeDefault;
      })
    );
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState(
      produce(draft => {
        draft[name] = value;
      })
    );
  };

  showInput = () => {
    const { uid } = this.props;
    const { cName } = this.state;
    return (
      <form onSubmit={e => this.handleSubmit(uid, cName, e)}>
        <input
          type="text"
          name="cName"
          value={cName}
          onChange={this.handleChange}
        />
        <button type="submit" className="ml-2 btn btn-sm btn-outline-success">
          완료
        </button>
      </form>
    );
  };

  handleSubmit = (uid, cName, e) => {
    e.preventDefault();
    const { cCodeDefault: oldName } = this.props;
    const newName = cName;
    console.log(uid, oldName, newName);
    if (oldName !== newName) {
      /** CALL ACTION */
      this.props.userClassCodeUpdate(uid, oldName, newName);
      this.setState(
        produce(draft => {
          draft.toggleInput = false;
          draft.cName = "";
        })
      );
    }
  };

  render() {
    const { toggleInput } = this.state;
    return (
      <div className="d-flex align-items-center">
        {toggleInput && <this.showInput />}
        <button
          className={`ml-2 btn btn-sm btn-outline-${
            toggleInput ? "danger" : "primary"
          }`}
          onClick={this.toggleInput}
        >
          {toggleInput ? "취소" : "수정 하기"}
        </button>
      </div>
    );
  }
}

export default connect(
  null,
  { userClassCodeUpdate }
)(ModifyCCode);
